    export function epcPriceFilter(input: string, replaceText: string, canView: boolean): string {
        return '$' + parseFloat(input).toFixed(2) + '/w';
    }